export const routes = {
  signIn: '/signin',
  dayReport: '/reports/day',
  monthReport: '/reports/month',
};